export default "__VITE_ASSET__bacc8bea__"